import * as React from 'react';
import { Text, View ,StyleSheet, TextInput ,TouchableOpacity ,useState} from 'react-native';
import { Entypo } from '@expo/vector-icons';
import Swal from 'sweetalert2'

export default function dadospessoaiscadastro({route,navigation}){
 
  
    const [telefone,setTelefone] = React.useState('');
    //const register bank


  const ativation=(telefone)=>{
    var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/trocarnumero.php';
    var headers={
     'Accept':'application/json',
     'Content-Type':'application.json',
     'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
     'Access-Control-Allow-Origin':'*',
     'crossDomain': 'true',
     'Host': 'https://emprestimoimperion.com/composer/controller/api/trocarnumero.php',
     'credentials': 'same-origin',
     'Access-Control-Allow-Credentials': 'true'
     
      };
     /*'crossDomain': 'true',*/
     var Data={
      telefone:telefone,
      id:route.params.userid,
      token:route.params.id,
      };
      console.log(route.params.id)
      fetch(validatinoApi,
      {
      method:'POST',
      headers:headers,
      body:JSON.stringify(Data)
      }).then((response)=>response.json())
      .then((response)=>{
      if(response.statusCode==200){
      navigation.navigate('logado')
      }else{
        Swal.fire({
          position: 'top',
          icon: 'error',
          title: 'Algo deu errado',
          showConfirmButton: false,
          timer: 2000
        })
      } 
      }).catch((error)=>{
      alert(error);
      });
      
    }
  
  

  


  return (
<View style={{ flex: 1, alignItems: 'center' ,backgroundColor:'#01150E' }}>

<Entypo name="add-user" size={80} color="white" margin={40} />
 

<TextInput
       onChangeText={(nome) => setTelefone(nome)}
       style={{height: 80,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{         
         
        }}
        placeholder="Telefone"
        keyboardType='numeric'
        
      />

      <TouchableOpacity onPress = {() => {/* do this */
      if(telefone.length>10&&telefone.length<12){
        ativation(telefone);
        
      }else{

        Swal.fire(
          'Algo errado?',
          'Coloque o numero com o DDD?',
          'error'
        )

      }}}>
    <View style = {{backgroundColor: 'white', alignItems: 'center', 
                    justifyContent: 'center' ,borderRadius: 10,width:110 }}
           >
        <Text style = {{ color: '#01150E', padding:10}}>Gravar</Text>
          </View>
</TouchableOpacity>

<View style={{marginTop:20}}>
</View>

</View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 16,
    marginVertical: 32,
  },
  section: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  paragraph: {
    fontSize: 15,
    color:'white'
  },
  checkbox: {
    margin: 8,
  },
});